import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsUfClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/uf');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Uf');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/uf', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Uf');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/uf', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Uf');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/uf/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Uf');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/uf/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Uf');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/uf/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Uf');
    }
  }
}
